import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import TurnstileCaptcha from 'react-turnstile'
import { ErrorMsg } from '@olxbr/design-system'

const TurnstileArea = styled.div`
  display: flex;
  margin-bottom: 8px;
  justify-content: center;
`

const TurnstileContent = styled.div`
  display: flex;
  width: 300px;
  flex-direction: column;
`

export const Turnstile = ({ onLoad, onVerify, hasError }) => {
  const turnstileSiteKey = '0x4AAAAAAADmGIS5l8Nlxuco'
  const [error, setError] = useState(false)

  useEffect(() => {
    setError(hasError)
  }, [hasError])

  const onTurnstileLoad = () => {
    if (onLoad) {
      onLoad()
    }
  }

  const onTurnstileVerify = token => {
    if (onVerify) {
      onVerify(token)
    }
  }

  return (
    <TurnstileArea>
      <TurnstileContent>
        <TurnstileCaptcha
          sitekey={turnstileSiteKey}
          theme="light"
          onVerify={onTurnstileVerify}
          onLoad={onTurnstileLoad}
        />
        {error && <ErrorMsg>Captcha não preenchido</ErrorMsg>}
      </TurnstileContent>
    </TurnstileArea>
  )
}

Turnstile.propTypes = {
  onLoad: PropTypes.func,
  onVerify: PropTypes.func,
  hasError: PropTypes.bool,
}
